import React, { Component } from 'react';
import { View, Image, Platform } from 'react-native';
import Text from '../components_v2/TextFont';
import { BRANDING } from '../../assets/consts';
import { translate } from '../locales/translate';
import { Spinner } from 'native-base';

export default class Loading extends Component {
    render() {
        return (
            <View style={{ ...this.props.style, flex: 1, alignItems: 'center', justifyContent: 'center' }}>
                {Platform.OS == "web" ? <Spinner size="lg" color="PRIMARY"  my="5"/> : <Image style={{ ...this.props.imageStyle }} source={BRANDING.LOADING} />}
                <Text >{this.props.message || translate('app.loading')}</Text>
            </View>
        );
    }
}